/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DocumentResponse,
  FileStreamResult,
  ProblemDetails,
  UploadLinkResponse,
} from '../models/index';
import {
    DocumentResponseFromJSON,
    DocumentResponseToJSON,
    FileStreamResultFromJSON,
    FileStreamResultToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UploadLinkResponseFromJSON,
    UploadLinkResponseToJSON,
} from '../models/index';

export interface CreateUploadLinkRequest {
    clientId: string;
}

export interface DeactivateUploadLinkRequest {
    clientId: string;
}

export interface DeleteClientSelfUploadRequest {
    token: string;
    documentId: string;
}

export interface GetActiveUploadLinkRequest {
    clientId: string;
}

export interface GetClientSelfUploadPreviewRequest {
    token: string;
    documentId: string;
}

export interface GetClientSelfUploadThumbnailRequest {
    token: string;
    documentId: string;
}

export interface GetClientSelfUploadsRequest {
    token: string;
}

export interface UploadClientDocumentRequest {
    token: string;
}

export interface ValidateUploadTokenRequest {
    token: string;
}

/**
 * TokenUploadApi - interface
 * 
 * @export
 * @interface TokenUploadApiInterface
 */
export interface TokenUploadApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    createUploadLinkRaw(requestParameters: CreateUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadLinkResponse>>;

    /**
     */
    createUploadLink(requestParameters: CreateUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadLinkResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    deactivateUploadLinkRaw(requestParameters: DeactivateUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deactivateUploadLink(requestParameters: DeactivateUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} token 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    deleteClientSelfUploadRaw(requestParameters: DeleteClientSelfUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteClientSelfUpload(requestParameters: DeleteClientSelfUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    getActiveUploadLinkRaw(requestParameters: GetActiveUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadLinkResponse>>;

    /**
     */
    getActiveUploadLink(requestParameters: GetActiveUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadLinkResponse>;

    /**
     * 
     * @param {string} token 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    getClientSelfUploadPreviewRaw(requestParameters: GetClientSelfUploadPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>>;

    /**
     */
    getClientSelfUploadPreview(requestParameters: GetClientSelfUploadPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult>;

    /**
     * 
     * @param {string} token 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    getClientSelfUploadThumbnailRaw(requestParameters: GetClientSelfUploadThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>>;

    /**
     */
    getClientSelfUploadThumbnail(requestParameters: GetClientSelfUploadThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult>;

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    getClientSelfUploadsRaw(requestParameters: GetClientSelfUploadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentResponse>>>;

    /**
     */
    getClientSelfUploads(requestParameters: GetClientSelfUploadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentResponse>>;

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    uploadClientDocumentRaw(requestParameters: UploadClientDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>>;

    /**
     */
    uploadClientDocument(requestParameters: UploadClientDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse>;

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenUploadApiInterface
     */
    validateUploadTokenRaw(requestParameters: ValidateUploadTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    validateUploadToken(requestParameters: ValidateUploadTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class TokenUploadApi extends runtime.BaseAPI implements TokenUploadApiInterface {

    /**
     */
    async createUploadLinkRaw(requestParameters: CreateUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadLinkResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createUploadLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/upload-token`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadLinkResponseFromJSON(jsonValue));
    }

    /**
     */
    async createUploadLink(requestParameters: CreateUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadLinkResponse> {
        const response = await this.createUploadLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deactivateUploadLinkRaw(requestParameters: DeactivateUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deactivateUploadLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/upload-token`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deactivateUploadLink(requestParameters: DeactivateUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivateUploadLinkRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteClientSelfUploadRaw(requestParameters: DeleteClientSelfUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling deleteClientSelfUpload().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteClientSelfUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/upload/{token}/documents/{documentId}`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteClientSelfUpload(requestParameters: DeleteClientSelfUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClientSelfUploadRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getActiveUploadLinkRaw(requestParameters: GetActiveUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadLinkResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getActiveUploadLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/upload-token`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadLinkResponseFromJSON(jsonValue));
    }

    /**
     */
    async getActiveUploadLink(requestParameters: GetActiveUploadLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadLinkResponse> {
        const response = await this.getActiveUploadLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientSelfUploadPreviewRaw(requestParameters: GetClientSelfUploadPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getClientSelfUploadPreview().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getClientSelfUploadPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/upload/{token}/documents/{documentId}/preview`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     */
    async getClientSelfUploadPreview(requestParameters: GetClientSelfUploadPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.getClientSelfUploadPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientSelfUploadThumbnailRaw(requestParameters: GetClientSelfUploadThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getClientSelfUploadThumbnail().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getClientSelfUploadThumbnail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/upload/{token}/documents/{documentId}/thumbnail`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     */
    async getClientSelfUploadThumbnail(requestParameters: GetClientSelfUploadThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.getClientSelfUploadThumbnailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientSelfUploadsRaw(requestParameters: GetClientSelfUploadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentResponse>>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getClientSelfUploads().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/upload/{token}/documents`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentResponseFromJSON));
    }

    /**
     */
    async getClientSelfUploads(requestParameters: GetClientSelfUploadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentResponse>> {
        const response = await this.getClientSelfUploadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadClientDocumentRaw(requestParameters: UploadClientDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling uploadClientDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/upload/{token}`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadClientDocument(requestParameters: UploadClientDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse> {
        const response = await this.uploadClientDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async validateUploadTokenRaw(requestParameters: ValidateUploadTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling validateUploadToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/upload/{token}/validate`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async validateUploadToken(requestParameters: ValidateUploadTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.validateUploadTokenRaw(requestParameters, initOverrides);
    }

}
